import React from 'react';
import styled from 'styled-components';
import { FieldPanelFullWidth } from 'styles/v2/Styles.styled';
import UserSettingsRequestsTab from './my-requests-tab/UserSettingsRequestsTab';
import UserSettingsInvitesTab from './invites-tab/UserSettingsInvitesTab';
import UserSettingsMyRolesTab from './my-roles-tab/UserSettingsMyRolesTab';
import { Link, useParams } from 'react-router-dom';
import { EpdLinks } from 'routes/EpdRoutes';

interface UserSettingsMembershipProps {
  userId?: string;
}

type TabKey = 'myRoles' | 'myRequests' | 'invites';

const UserSettingsRolesAndOrganisationsTab: React.FC<UserSettingsMembershipProps> = ({ userId }) => {
  const { subTab } = useParams<{ subTab: TabKey | undefined }>();
  const activeTab = subTab || 'myRoles';

  const renderTabContent = () => {
    switch (activeTab) {
      case 'myRoles':
        return <UserSettingsMyRolesTab />;
      case 'myRequests':
        return <UserSettingsRequestsTab />;
      case 'invites':
        return <UserSettingsInvitesTab />;
      default:
        return null;
    }
  };

  return (
    <StyledPanel>
      <TabNavigation>
        <MenuItem $active={activeTab === 'myRoles'} to={EpdLinks.userSettings('membership', 'myRoles')}>
          My roles
        </MenuItem>
        <MenuItem $active={activeTab === 'myRequests'} to={EpdLinks.userSettings('membership', 'myRequests')}>
          My requests
        </MenuItem>
        <MenuItem $active={activeTab === 'invites'} to={EpdLinks.userSettings('membership', 'invites')}>
          Invites
        </MenuItem>
      </TabNavigation>
      <TabContentContainer>{renderTabContent()}</TabContentContainer>
    </StyledPanel>
  );
};

const TabNavigation = styled.div`
  display: flex;
  border-bottom: 2px solid ${(props) => props.theme.colors.elementsInputBorder};
`;

const MenuItem = styled(Link)<{ $active?: boolean }>`
  padding: 15px 22px;
  line-height: 1;
  color: ${(props) => (props.$active ? props.theme.colors.primaryGreen : props.theme.colors.elementsButtonDisabled)};
  align-items: center;
  border: none;
  border-bottom: 2px solid ${(props) => (props.$active ? props.theme.colors.green : 'transparent')};
  background-color: transparent;
  text-decoration: none;
  font-size: 0.875rem;
  font-weight: 600;

  position: relative;
  margin-bottom: ${(props) => (props.$active ? '-2px' : '0')};
  z-index: ${(props) => (props.$active ? 2 : 0)};

  &:hover,
  &:focus-visible {
    color: ${(props) => props.theme.colors.primaryBlack};
    background-color: ${(props) => props.theme.colors.lightGray};
    z-index: 1;
  }
`;

const TabContentContainer = styled.div`
  ${(props) => props.theme.media.desktop} {
    min-height: 670px;
  }
`;

const StyledPanel = styled(FieldPanelFullWidth)`
  margin-top: 0;
  padding-top: 0;
  padding-left: 0.5rem;
  background-color: #f6f6f6;
  border: none;
  box-shadow: 0px 0px 0px 0px rgba(0, 0, 0, 0);
  row-gap: 16px;
`;

export default UserSettingsRolesAndOrganisationsTab;
